import momentTZ from 'moment-timezone';
import moment from 'moment';

export function parseDate(times) {
    if (moment(times).isValid()) {
        return momentTZ.tz(times, 'Asia/Ho_Chi_Minh').format('HH:mm:ss DD/MM/YYYY')
      } else {
        return times;
      }
}

export function timestampToTime(timestamp) {

    var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

    var Y = date.getFullYear() + '-';

    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

    var D = date.getDate() + ' ';

    var h = date.getHours() + ':';

    var m = date.getMinutes();

    // var s = date.getSeconds();

    return Y + M + D + h + m;

}

export function milliFormat(num) {
    return (
        num &&
        num.toString().replace(/\d+/, function (s) {
            return s.replace(/(\d)(?=(\d{3})+$)/g, "$1.");
        })
    );
}

export function phoneNumFormat(str) {
    let result = str.toString();
    if (result && result.length === 10) {
        result = result.replace(/ /g, '');
        result = result.substr(0, 3) + ' ' + result.substr(3, 3) + ' ' + result.substr(6, 4);
    }
    return result;
}